// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"CategoriesFilter_text-gradient__3Fudb","tag":"CategoriesFilter_tag__3ktPZ","active":"CategoriesFilter_active__20sWM","icon":"CategoriesFilter_icon__ZkxNd"};